import request from '@/axios';

export const getPage = (current, size, params) => {
  return request({
    url: '/emp-data-center/emp-data/model/page',
    method: 'get',
    filterEmptyParams: true,
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (modelId) => {
  return request({
    url: '/emp-data-center/emp-data/model/detail',
    method: 'get',
    params: {
      modelId
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/emp-data-center/emp-data/model/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/emp-data-center/emp-data/model/save',
    method: 'post',
    data: row
  })
}
export const getModelList = (params) => {
  return request({
    url: '/emp-data-center/emp-data/model/list',
    method: 'get',
    params
  })
}
// table B
export const getList = (params) => {
  return request({
    url: '/emp-data-center/emp-data/model/itemlist',
    method: 'get',
    params
  })
}
export const getItemPage = (current, size, params) => {
  return request({
    url: '/emp-data-center/emp-data/model/itemPage',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

// 下拉框
export const getItemList = (current, size, params) => {
  return request({
    url: '/emp-data-center/emp-data/model/itemList',
    method: 'get',
    params
  })
}

// 编辑列表带很多数据
export const getItemLists = (current, size, params) => {
  return request({
    url: '/emp-data-center/emp-data/model/itemLists',
    method: 'get',
    params
  })
}

export const getItemDetail = (id) => {
  return request({
    url: '/emp-data-center/emp-data/model/itemDetail',
    method: 'get',
    params: {
      id
    }
  })
}

export const updateItem = (row) => {
  return request({
    url: '/emp-data-center/emp-data/model/updateItem',
    method: 'post',
    data: row
  })
}

export const itmeRemove = (ids) => {
  return request({
    url: '/emp-data-center/emp-data/model/itmeRemove',
    method: 'post',
    params: {
      ids,
    }
  })
}